import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class StatusControlPinTask extends AbstractRequestTask {
  constructor(params, version = 'v1') {
    super();
    this.ownParams = params;
    this.version = version;
  }

  getParams() {
    const params = super.getParams();
    const user = store.getState().user;
    const user_id = user.user_id || "";
    if(params.user_token) {
      delete params.api_version;
      delete params.HKS;
    }
    return Object.assign({}, params, { user_id, ...this.ownParams });
  }

  getShowErrorModal(){
    return DISABLE_MODAL_RETRIES;
  }

  getUrl() {
    const params = super.getParams();
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'statuscontrolpin';
    const url = params.user_token ? `${protocol}://${server}/${endpoint}/${version}/${apiname}` : `${protocol}://${server}/${endpoint}/${apiname}`

    return url;
  }
}

export default StatusControlPinTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/StatusControlPinTask.js